import axiosInstance from "./api";
import { COMPANIES_URL } from "../configs/api";

export const getCompanyByIdApi = (id) => axiosInstance.get(COMPANIES_URL + id);
export const updateCompanyApi = (id, body) =>
  axiosInstance.put(COMPANIES_URL + id, body);
